module.exports = __webpack_public_path__ + "img/nabl_gallery5.b94e3b20.jpg";